import { useMutation } from '@tanstack/react-query'

import { pqClient } from '@/features/prequalification/localControl/endpoints/pqClient'
import type { ApiClearQueueResponse } from '@/features/prequalification/localControl/types'
import type { UseMutationOptions } from '@/types/queries'

export function useClearLocalPqQueueMutation(options?: UseMutationOptions<ApiClearQueueResponse, string>) {
  const { mutateAsync, ...mutationResult } = useMutation({
    ...options,
    mutationFn: (resourceId: string) => pqClient.clearQueue(resourceId),
  })

  return { clearQueue: mutateAsync, ...mutationResult }
}
